<mat-card class="mx-2 my-3 shadow">
  <div class="label-holder">
    <span class="content-label" translate>Send promocode</span>
  </div>

  <div class="form-container">
    <form [formGroup]="promoForm">
      <div class="content-details-blk">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="row g-0">
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <h4 class="form-item-label" translate>
                  pages.newRetailer.carrier
                  <span class="required">*</span>
                </h4>
              </div>
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select
                      formControlName="carrier"
                      placeholder="Select payment type"
                    >
                      <!-- <mat-option
                              *ngFor="let carrier of carriers"
                              [value]="carrier.carrier"
                            >
                              {{ carrier.carrier }}
                            </mat-option> -->
                      <mat-option value="AIRTEL">AIRTEL</mat-option>
                      <mat-option value="Digicel">Digicel</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row g-0">
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <h4 class="form-item-label" translate>
                  pages.newRetailer.amount
                  <span class="required">*</span>
                </h4>
              </div>
              <div
                class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
              >
                <div class="row">
                  <div class="col-12 col-xs-12 col-sm-6">
                    <div class="form-item-input small-form-items">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select placeholder="min">
                          <mat-option value="10">$ 10</mat-option>
                          <mat-option value="20">$ 20</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-12 col-xs-12 col-sm-6">
                    <div class="form-item-input small-form-items">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select placeholder="max">
                          <mat-option value="10">$ 10</mat-option>
                          <mat-option value="20">$ 20</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-0">
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <h4 class="form-item-label" translate>
                  {{'pages.Promocodehistory.Validity' | translate }}
                  <span class="required">*</span>
                </h4>
              </div>
              <div
                class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
              >
                <div class="row">
                  <div class="col-12 col-xs-12 col-sm-6">
                    <div class="form-item-input small-form-items">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select placeholder="from">
                          <mat-option value="10">$ 10</mat-option>
                          <mat-option value="20">$ 20</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-12 col-xs-12 col-sm-6">
                    <div class="form-item-input small-form-items">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select placeholder="to">
                          <mat-option value="10">$ 10</mat-option>
                          <mat-option value="20">$ 20</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-0">
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <h4 class="form-item-label" translate>Text message</h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <textarea
                      matInput
                      formControlName="productDescription"
                      placeholder="productDescription"
                      class="text-area"
                    >
                    </textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="row g-0">
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <h4 class="form-item-label" translate>
                  {{ 'pages.RealtimeTransactions.Product' | translate }}
                  <span class="required">*</span>
                </h4>
              </div>
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select
                      formControlName="product"
                      placeholder="Select product type"
                    >
                      <mat-option
                        *ngFor="let type of productTypes"
                        [value]="type"
                      >
                        {{ type }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div *ngIf="f.product.touched && f.product.invalid">
                    <div *ngIf="f.product.errors.required">
                      <mat-hint class="text-danger ms-2">
                        Product type is required.</mat-hint
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-0">
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <h4 class="form-item-label" translate>pages.newRetailer.productDescription</h4>
              </div>
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <textarea
                      matInput
                      formControlName="productDescription"
                      placeholder="productDescription"
                      class="text-area"
                    >
                    </textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row g-0">
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <h4 class="form-item-label" translate>
                  {{'pages.Promocodehistory.Country' | translate }} <span class="required">*</span>
                </h4>
              </div>
              <div
                class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
              >
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select placeholder="Select country">
                      <mat-option
                        *ngFor="let country of countries"
                        [value]="country.countryName"
                        >{{ country.countryName }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-footer">
        <ul class="list-inline text-center">
          <li class="list-inline-item">
            <button
              mat-raised-button
              [disabled]="!promoForm.valid"
              color="primary"
              type="submit"
              class="rounded-0"
            >
            <span translate class="translate">pages.newRetailer.send</span>
            </button>
          </li>
          <li class="list-inline-item">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="rounded-0"
              (click)="onCancel()"
            >
              <span translate class="translate">pages.newRetailer.cancel</span>
            </button>
          </li>
        </ul>
      </div>
    </form>
  </div>
</mat-card>
